import React, { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import ForwardIcon from '@mui/icons-material/Forward';
import {
  Button,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Unstable_Grid2 as Grid,
} from '@mui/material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import * as paths from 'paths';
import { useContent } from 'hooks';
import { Events } from 'analytics';
import { Buttons, CustomSVG } from 'components';

import { useCanShare } from 'features/content/hooks';
import { isEngageable } from 'features/content/helpers';
import { Engage } from 'features/content/widgets';

const PostCardButtons: FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const content = useContent();
  const navigate = useNavigate();

  const showShare = useCanShare(content);
  const showEngage = isEngageable(content);

  const { content_id } = content;

  function onClickShare() {
    navigate(`/content/${content_id}`);

    const searchParams = new URLSearchParams(location.search);
    window?.analytics?.track(Events.ShareInitiated, {
      content_id,
      referral_source: searchParams.get('es_source'),
    });
  }

  function onClickShared() {
    navigate(paths.activity, { state: 'sharedButton' });
  }

  function renderShare() {
    if (content.has_requesting_user_shared) {
      return (
        <Buttons.SubAction name={t('common:shared')} variant="outlined" size="medium">
          <MenuList>
            <MenuItem onClick={onClickShared}>
              <ListItemIcon>
                <AssessmentIcon />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ variant: 'subtitle2' }}
                primary={t('content:viewPerformance')}
              />
            </MenuItem>
            <MenuItem onClick={onClickShare}>
              <ListItemIcon>
                <ForwardIcon />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ variant: 'subtitle2' }}
                primary={t('content:shareAgain')}
              />
            </MenuItem>
          </MenuList>
        </Buttons.SubAction>
      );
    }

    return (
      <Button
        variant="contained"
        color="primary"
        onClick={onClickShare}
        endIcon={<CustomSVG name="share" size={20} />}
        sx={{
          padding: theme.spacing(0.5, 2),
          border: 'none',
          borderRadius: 4,
          width: 94,
        }}
      >
        {t('content:share')}
      </Button>
    );
  }

  return (
    <Grid container justifyContent="center" spacing={3} alignItems="center">
      {showShare && <Grid>{renderShare()}</Grid>}
      {showEngage && (
        <Grid>
          <Engage />
        </Grid>
      )}
    </Grid>
  );
};

export default PostCardButtons;
